<div class="modal-header">
  <h4 class="modal-title">{{ dialogHeader }}</h4>
</div>
<div class="modal-body" (keyup.esc)="cancel()" (keyup.enter)="enterPressed()">
  @if (dialogPrompt) {
    <div class="mb-2">{{ dialogPrompt }}</div>
  }
  @if (mode === 'text') {
    <div>
      <dx-text-box #inputComponent [(value)]="dialogValue" valueChangeEvent="input"></dx-text-box>
    </div>
  }
  @if (mode === 'password') {
    <div>
      <dx-text-box #inputComponent [(value)]="dialogValue" [mode]="'password'" valueChangeEvent="input" (onInput)="onInput($event)"></dx-text-box>
    </div>
  }
  @if (mode === 'textarea') {
    <div>
      <dx-text-area #inputComponent [(value)]="dialogValue" [height]="300"></dx-text-area>
    </div>
  }
  @if (mode === 'date') {
    <div>
      <dx-date-box #inputComponent [(value)]="dialogValue"></dx-date-box>
    </div>
  }
  @if (mode === 'select') {
    <div>
      <dx-select-box #inputComponent [(value)]="dialogValue" [items]="dialogValueArray"></dx-select-box>
    </div>
  }
  @if (mode === 'selectWithId') {
    <div>
      <dx-select-box #inputComponent [(value)]="dialogValue" [items]="dialogValueArray" [valueExpr]="'id'" [displayExpr]="'name'" ></dx-select-box>
    </div>
  }
  @if (!!dialogMessage) {
    <div class="mt-3">
      {{ dialogMessage }}
    </div>
  }
  @if (mode === 'list') {
    <div>
      <dx-list
        #selectList
        [dataSource]="dataSource"
        [searchEnabled]="true"
        searchMode="contains"
        [searchExpr]="'name'"
        [showSelectionControls]="true"
        [selectionMode]="listSelectMode"
        >
        <div *dxTemplate="let item of 'item'">
          <div>{{ item.name }}</div>
        </div>
      </dx-list>
    </div>
  }
  @if (mode === 'dataGrid') {
    <div>
      <dx-data-grid
        #dataGrid
        [dataSource]="dataSource"
        [height]="'350px'"
        [showBorders]="true"
        [columnAutoWidth]="false"
        [focusedRowEnabled]="false"
        [showColumnLines]="true"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        >
        <dxo-state-storing [enabled]="true" type="localStorage" [storageKey]="storageKey"></dxo-state-storing>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-search-panel [visible]="true"></dxo-search-panel>
        <dxo-selection [mode]="'single'"></dxo-selection>
        <div *dxTemplate="let data of 'toolbarButtons'">
        </div>
        <div *dxTemplate="let data of 'toolbarText'">
          @if (dataSource) {
            <span class="me-3">
              <strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong>
            </span>
          }
        </div>
      </dx-data-grid>
    </div>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-success" (click)="save(true)" [hidden]="!saveAndNewVisible">Save & New</button>
  <button type="button" class="btn btn-success" (click)="save()">Save</button>
  <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
</div>
